import { SIGN_OUT_ACCEPTED } from '@domain/auth/sign-out/sign-out-state';
import { createMiddleware } from '@shared/redux';
import { analytics } from '../analytics';

export const signOutMiddleware = createMiddleware({
    [SIGN_OUT_ACCEPTED]: async () => {
        analytics.reset();
    },
}, { beforeChanges: true });
